import { useSWR } from '@tiger/swr';
import security from 'stores/security';
import API from 'utils/API';

export interface AcceptedFundItem {
    name: string;
    // as symbol (ticker) passed to backend
    ticker: string;
    cusipNum: string;
    check?: string;
    classLevel?: string;
}

export function useSearchFund(keyword: string) {
    return useSWR<AcceptedFundItem[]>(
        !!keyword.trim() && {
            url: API.CUSTOMER.transfer.fundSearch(),
            params: {
                account_id: security.currentAccountId,
                key: keyword.trim(),
                match_type: 'like'
            }
        },
        {
            revalidateOnFocus: false,
            dataChain: resp => resp?.data || []
        }
    );
}
